import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`To set a `}<inlineCode parentName="p">{`ReturnPaymentState`}</inlineCode>{`, the Order needs to have the `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#returninfo"
        }}>{`ReturnInfo`}</a>{` set with at least one `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#returnitem"
        }}>{`ReturnItem`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setReturnPaymentState"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`returnItemId`}</inlineCode>{` - String - ID of the concerning `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#returnitem"
          }}>{`ReturnItem`}</a></li>
        <li parentName="ul"><inlineCode parentName="li">{`paymentState`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#returnpaymentstate"
          }}>{`ReturnPaymentState`}</a>{` - New ReturnPaymentState according to `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#returnpaymentstate"
          }}>{`allowed transitions`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      